/* PDP / footer / FAQ accordion - single row open at a time

   Fabric's own accordion has no "only one open" setting, so this is the
   coordinator. `toggle` does not bubble, per spec, so the listener is attached
   with useCapture rather than the usual delegated pattern. The animation itself
   is CSS only; this file only ever sets .open.

   The footer is scoped by .yg-footer-section, not by Shopify's
   #shopify-section-{id}: that carries a volatile per-page-instance numeric
   prefix for grouped sections, so it cannot be hardcoded in a selector. */

(function () {
  'use strict';

  var ACCORDION = '.product-information .accordion, .yg-footer-section, .yg-faq__list';
  var bound = new WeakSet();
  var observer = new MutationObserver(schedule);
  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      init();
    });
  }

  function init() {
    var accordions = document.querySelectorAll(ACCORDION);

    for (var i = 0; i < accordions.length; i++) {
      var accordion = accordions[i];

      /* sections re-render in the theme editor - bind whatever replaces it */
      if (accordion.parentElement) observer.observe(accordion.parentElement, { childList: true });

      if (bound.has(accordion)) continue;
      bound.add(accordion);
      accordion.addEventListener('toggle', handleToggle, true);
    }
  }

  /**
   * @param {Event} event
   */
  function handleToggle(event) {
    var opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;

    var accordion = event.currentTarget;

    /* The footer's three columns stay independently open on desktop. Each sets
       its own `open` at load via accordion-custom.js, which itself fires a
       toggle event - without this check the first column to fire would close
       the other two the moment the page loads. */
    if (
      accordion instanceof Element &&
      accordion.classList.contains('yg-footer-section') &&
      window.matchMedia('(min-width: 750px)').matches
    ) {
      return;
    }

    var rows = accordion.querySelectorAll('details');

    for (var i = 0; i < rows.length; i++) {
      if (rows[i] !== opened) rows[i].open = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
